import { render, staticRenderFns } from "./saved-cards.vue?vue&type=template&id=58386b00&"
import script from "./saved-cards.vue?vue&type=script&lang=js&"
export * from "./saved-cards.vue?vue&type=script&lang=js&"
import style0 from "./saved-cards.vue?vue&type=style&index=0&id=58386b00&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports